<app-loading-splash />
<app-route-progress-bar />
<jj-maintenance-banner />
<div class="app-shell">
  <router-outlet></router-outlet>
</div>
